<template>
  <OrganismModal
    v-model:is-shown="isOpen"
    :title="t('subscription.billingMode.annualBudget.modal.title')"
    title-icon-name="InformationCircleIcon"
    has-separator
    size="lg"
    @cancel="isOpen = false"
  >
    <BudgetDetail />

    <template #footer>
      <div class="flex justify-end">
        <MoleculeButton variant="tertiary" :label="t('common.close')" @clicked="isOpen = false" />
      </div>
    </template>
  </OrganismModal>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import BudgetDetail from './BudgetDetail.component.vue';

const isOpen = defineModel<boolean>('isOpen', { required: true });

const { t } = useI18n();
</script>
